import { useMutation } from "@tanstack/react-query"

import {
  saveAffiliateByProductId,
  trackingSaveLink,
  unSaveAffiliateByProductId
} from "@/api"

interface UseAffiliateMutationsOptions {
  onSaveSuccess?: () => void
  onUnsaveSuccess?: () => void
  onSaveLinkSuccess?: () => void
}

export const useAffiliateMutations = (
  id: string | undefined,
  options: UseAffiliateMutationsOptions = {}
) => {
  const { onSaveSuccess, onUnsaveSuccess, onSaveLinkSuccess } = options

  const save = useMutation({
    mutationKey: ["save_product", id],
    mutationFn: (productId: string) => saveAffiliateByProductId(productId),
    onSuccess: onSaveSuccess
  })

  const unSave = useMutation({
    mutationKey: ["unsave_product", id],
    mutationFn: (productId: string) => unSaveAffiliateByProductId(productId),
    onSuccess: onUnsaveSuccess
  })

  const saveLink = useMutation({
    mutationKey: ["tracking_save_link", id],
    mutationFn: (productId: string) => trackingSaveLink(productId),
    onSuccess: onSaveLinkSuccess,
    onError: (error) => {
      console.error("Save link error:", error)
    }
  })

  return { 
    save, 
    unSave, 
    saveLink,
    isLoading: save.isPending || unSave.isPending || saveLink.isPending
  }
}
